export const defaultPassInfo = {
  name: "", // 乘客姓名
  firstName: "", // 乘客名英文名
  lastName: "", // 乘客姓英文姓
  birthday: "", // 出生日期
  gender: "", // 性别
  mobile: "", // 电话
  certNo: "", // 证件号
  certType: "PP", // 证件类型
  certIssuePlace: "", // 证书签发国家码
  certExpired: "", // 证件有效期
  nationality: "" // 国籍
};

export const messageMap = {
  firstName: "英文姓不能为空",
  lastName: "英文名不能为空",
  certType: "证件类型不能为空",
  certNo: "证件号不能为空",
  gender: "性别不能为空",
  birthday: "出生日期不能为空",
  certIssuePlace: "签发国家不能为空",
  nationality: "国籍不能为空",
  certExpired: "证件有效期不能为空",
  mobile: "手机号不能为空"
};

export const passTypeMap = {
  ADT: "成人",
  CHD: "儿童",
  INF: "婴儿"
};

export const intCertTypeList = [
  { text: "护照", code: "PP" },
  { text: "电子护照", code: "IP" }
];
